var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.className,attrs:{"role":"navigation","disabled":_vm.disabled,"type":"button"},on:{"click":_vm.navigate}},[_c('span',{staticClass:"SubTab__text"},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }